import { render, staticRenderFns } from "./CallsInteraction.vue?vue&type=template&id=403fb089&scoped=true"
import script from "./CallsInteraction.vue?vue&type=script&lang=js"
export * from "./CallsInteraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403fb089",
  null
  
)

export default component.exports